// Bump to invalidate previously-saved local user data (config, files, projects).
const STORAGE_APPEND_ID = "24";

export const LOCAL_DATA_CONFIG = "ndp3Data_config_" + STORAGE_APPEND_ID;
export const LOCAL_DATA_FILES_ID = "ndp3Data_files_" + STORAGE_APPEND_ID;
export const LOCAL_DATA_PROJECTS_ID = "ndp3Data_projects_" + STORAGE_APPEND_ID;
